var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "pega-input",
      attrs: {
        target: "_blank",
        href: _vm.bossCUrl + "/help/guide/index_283.html",
        "data-test": "provision-list-link",
      },
    },
    [_vm._v("登録情報規定一覧")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }